/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Pause: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="pause" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M453.3333333333334 1133.3333333333333L453.3333333333334 226.6666666666668H377.7777777777778L377.7777777777778 1133.3333333333333L453.3333333333334 1133.3333333333333zM982.2222222222222 1133.3333333333333L982.2222222222222 226.6666666666668H906.6666666666669L906.6666666666669 1133.3333333333333L982.2222222222222 1133.3333333333333z" : "M362.6666666666667 906.6666666666669L362.6666666666667 181.3333333333334H302.2222222222223L302.2222222222223 906.6666666666669L362.6666666666667 906.6666666666669zM785.7777777777777 906.6666666666669L785.7777777777777 181.3333333333334H725.3333333333333L725.3333333333333 906.6666666666669L785.7777777777777 906.6666666666669z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Pause.displayName = `Blueprint5.Icon.Pause`;
export default Pause;
